/* v26 (owner, 2026-10-28: "make it slowly appear when the user scrolls down"): a heading marked data-dex-rise comes in
   word by word with the scroll - each word rises out of a blur into place, the next one starting before the last has
   finished - and is whole by the time it reaches the middle of the screen. A word with "Dex" in it gets the brand
   gradient. Without the script (or with less motion) the heading simply shows. */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  document.querySelectorAll('[data-dex-rise]').forEach(function (el) {
    var words = [];
    var walk = function (node) {
      if (node.nodeType === 3) {
        var frag = document.createDocumentFragment();
        node.textContent.split(/(\s+)/).forEach(function (part) {
          if (!part) return;
          if (/^\s+$/.test(part)) { frag.appendChild(document.createTextNode(part)); return; }
          var w = document.createElement('span');
          w.className = 'dex-rw' + (/Dex/.test(part) ? ' is-brand' : '');
          w.textContent = part;
          frag.appendChild(w);
          words.push(w);
        });
        node.parentNode.replaceChild(frag, node);
      } else if (node.nodeType === 1) {
        Array.prototype.slice.call(node.childNodes).forEach(walk);
      }
    };
    Array.prototype.slice.call(el.childNodes).forEach(walk);
    el.classList.add('is-split');
    if (reduce || !words.length) { el.style.setProperty('--dex-rise', '1'); return; }
    var n = words.length;
    var tick = function () {
      var r = el.getBoundingClientRect();
      var vh = window.innerHeight;
      // 0 as the heading's top comes in at the bottom of the screen, 1 when it is a little above the middle
      var p = Math.min(1, Math.max(0, (vh * 0.98 - r.top) / (vh * 0.6)));
      el.style.setProperty('--dex-rise', p.toFixed(3));
      words.forEach(function (w, k) {
        var a = Math.min(1, Math.max(0, p * (n + 1.2) - k));
        var e = 1 - Math.pow(1 - a, 3);
        w.style.opacity = (0.04 + 0.96 * e).toFixed(3);
        w.style.transform = e < 1 ? 'translateY(' + ((1 - e) * 0.42).toFixed(3) + 'em)' : 'none';
        w.style.filter = e < 0.995 ? 'blur(' + ((1 - e) * 14).toFixed(1) + 'px)' : 'none';
      });
    };
    tick();
    window.addEventListener('scroll', function () { requestAnimationFrame(tick); }, { passive: true });
    window.addEventListener('resize', tick);
  });
})();
